export const roleConstant = {
    CURRENT_ROLE_ACTIVE: 'CURRENT_ROLE_ACTIVE',
};